/** Up to two initials, so the avatar works for "Анна" and for "Анна Ли". */
export function initials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean).slice(0, 2);
  return words.map((w) => [...w][0]?.toUpperCase() ?? '').join('') || '?';
}

const HUES = [210, 265, 330, 25, 150, 190, 300, 95];

/** Stable colour per person: same name, same avatar, every session. */
export function hueFor(seed: string): number {
  let hash = 0;
  for (const ch of seed) hash = (hash * 31 + ch.codePointAt(0)!) % 100000;
  return HUES[hash % HUES.length]!;
}
